export const cardThemes = {
  navy: "bg-[#050B5C] text-white",
  green: "bg-[#37A800] text-white",
  amber: "bg-[#D4A200] text-white",
  red: "bg-[#A50000] text-white",
  blue: "bg-[#0655A3] text-white",
};

export const reportSectionIds = {
  posicaoCarga: "posicao-carga",
  autosservico: "autosservico",
  creditoClientes: "credito-clientes",
};

export const createStatsSection = ({
  id,
  title,
  period,
  actions = [],
  cards = [],
}) => {
  return {
    id,
    title,
    period,
    actions,
    cards,
  };
};

export const createStatsCard = ({
  title,
  value,
  subtitle,
  color = "navy",
}) => {
  return {
    title,
    value,
    subtitle,
    color,
  };
};

export const defaultReportSections = [
  {
    id: "posicao-carga",
    title: "Posição de carga em",
    period: "Marco/2026",
    actions: [
      {
        key: "rota",
        label: "Pedidos da rota",
        active: true,
        cards: [
          {
            title: "Pedidos da rota",
            value: "80 pedidos",
            subtitle: "+5% vs M-1",
            color: "navy",
          },
          {
            title: "Total de pedidos entregues no mês",
            value: "60 pedidos",
            subtitle: "+2% vs M-1",
            color: "green",
          },
          {
            title: "Total de pedidos em trânsito",
            value: "10 pedidos",
            color: "amber",
          },
          {
            title: "Total de pedidos atrasados",
            value: "10 pedidos",
            color: "red",
          },
        ],
      },
      {
        key: "todos",
        label: "Todos os pedidos",
        active: false,
        cards: [
          {
            title: "Todos os pedidos",
            value: "120 pedidos",
            subtitle: "+8% vs M-1",
            color: "navy",
          },
          {
            title: "Total de pedidos entregues no mês",
            value: "95 pedidos",
            subtitle: "+6% vs M-1",
            color: "green",
          },
          {
            title: "Total de pedidos em trânsito",
            value: "15 pedidos",
            color: "amber",
          },
          {
            title: "Total de pedidos atrasados",
            value: "10 pedidos",
            color: "red",
          },
        ],
      },
    ],
    cards: [
      {
        title: "Pedidos da rota",
        value: "80 pedidos",
        subtitle: "+5% vs M-1",
        color: "navy",
      },
      {
        title: "Total de pedidos entregues no mês",
        value: "60 pedidos",
        subtitle: "+2% vs M-1",
        color: "green",
      },
      {
        title: "Total de pedidos em trânsito",
        value: "10 pedidos",
        color: "amber",
      },
      {
        title: "Total de pedidos atrasados",
        value: "10 pedidos",
        color: "red",
      },
    ],
  },
  {
    id: "autosservico",
    title: "Autosserviço em",
    period: "Marco/2026",
    actions: [
      {
        key: "rota",
        label: "Clientes da rota",
        active: true,
        cards: [
          {
            title: "Pedidos da rota",
            value: "80 pedidos",
            subtitle: "+5% vs M-1",
            color: "navy",
          },
          {
            title: "% de pedidos no web cliente",
            value: "25,8%",
            subtitle: "Mix web cliente: 4,44",
            color: "green",
          },
          {
            title: "% de pedidos no web vendedor",
            value: "66,9%",
            subtitle: "Mix web vendedor: 3,32",
            color: "amber",
          },
          {
            title: "% de pedidos em outros canais",
            value: "7,3%",
            subtitle: "Mix outros canais: 3,21",
            color: "blue",
          },
        ],
      },
      {
        key: "todos",
        label: "Todos os clientes",
        active: false,
        cards: [
          {
            title: "Pedidos da rota",
            value: "80 pedidos",
            subtitle: "+5% vs M-1",
            color: "navy",
          },
          {
            title: "% de pedidos no web cliente",
            value: "25,8%",
            subtitle: "Mix web cliente: 4,44",
            color: "green",
          },
          {
            title: "% de pedidos no web vendedor",
            value: "66,9%",
            subtitle: "Mix web vendedor: 3,32",
            color: "amber",
          },
          {
            title: "% de pedidos em outros canais",
            value: "7,3%",
            subtitle: "Mix outros canais: 3,21",
            color: "blue",
          },
        ],
      },
    ],
    cards: [
      {
        title: "Pedidos da rota",
        value: "80 pedidos",
        subtitle: "+5% vs M-1",
        color: "navy",
      },
      {
        title: "% de pedidos no web cliente",
        value: "25,8%",
        subtitle: "Mix web cliente: 4,44",
        color: "green",
      },
      {
        title: "% de pedidos no web vendedor",
        value: "66,9%",
        subtitle: "Mix web vendedor: 3,32",
        color: "amber",
      },
      {
        title: "% de pedidos em outros canais",
        value: "7,3%",
        subtitle: "Mix outros canais: 3,21",
        color: "blue",
      },
    ],
  },
  {
    id: "credito-clientes",
    title: "Crédito de clientes em",
    period: "Marco/2026",
    actions: [
      {
        key: "rota",
        label: "Clientes da rota",
        active: true,
        cards: [
          {
            title: "Desconto gerencial",
            value: "R$ 15.980,86",
            color: "amber",
          },
          {
            title: "Outros créditos",
            value: "R$ 6.120,16",
            color: "green",
          },
          {
            title: "Crédito total",
            value: "R$ 22.101,02",
            color: "navy",
          },
        ],
      },
      {
        key: "todos",
        label: "Todos os clientes",
        active: false,
        cards: [
          {
            title: "Desconto gerencial",
            value: "R$ 21.340,15",
            color: "amber",
          },
          {
            title: "Outros créditos",
            value: "R$ 8.774,90",
            color: "green",
          },
          {
            title: "Crédito total",
            value: "R$ 30.115,05",
            color: "navy",
          },
        ],
      },
    ],
    cards: [
      {
        title: "Desconto gerencial",
        value: "R$ 15.980,86",
        color: "amber",
      },
      {
        title: "Outros créditos",
        value: "R$ 6.120,16",
        color: "green",
      },
      {
        title: "Crédito total",
        value: "R$ 22.101,02",
        color: "navy",
      },
    ],
  },
];
